import * as React from 'react';
import { observer } from 'mobx-react';
import { CycleBudget } from 'nomst/Stores/Configuration/cycleBudget';
import { BudgetConfigurationViewStore } from 'nomst/Stores/Budget/budgetConfigurationView.store';
import InactiveBudgetTooltip from 'components/BudgetConfiguration/inactiveBudgetTooltip';

interface IBudgetBoxProps {
    budget: CycleBudget;
    budgetConfigurationViewStore: BudgetConfigurationViewStore;
    id: number;
}

export class BudgetBox extends React.Component<IBudgetBoxProps> {
    constructor(props: IBudgetBoxProps) {
        super(props);
        this.navigateToSelectedBudget = this.navigateToSelectedBudget.bind(this);
    }

    render(): React.ReactNode {
        const { budget, id } = this.props;
        return (
            <div className="budget-tile">
                <button onClick={this.navigateToSelectedBudget} className={budget.budgetClass + ' pxl-link'}>
                    <h2>{budget.name}</h2>
                    <h3>
                        <span>Associated Fields</span>
                        {budget.associatedFieldsText}
                    </h3>
                </button>
                <InactiveBudgetTooltip hidden={budget.isActive} id={id} />
            </div>
        );
    }

    private navigateToSelectedBudget(): void {
        const { budgetConfigurationViewStore, budget } = this.props;
        budgetConfigurationViewStore.navigateToBudgetView(budget);
    }
}

export default observer(BudgetBox);